import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { NOTIFICATION_TYPES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getNotificationTypesAction = createAsyncThunk(
    'communication/getNotificationTypesAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(NOTIFICATION_TYPES_PATH);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getNotificationTypesSlice = createSlice({
    name: 'getNotificationTypesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getNotificationTypesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getNotificationTypesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getNotificationTypesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getNotificationTypesState = (state) => state.communication.getNotificationTypes;
export default getNotificationTypesSlice.reducer;
